import { type Common } from '../common.js';
import { ORGANIZATION_ID_HEADER_KEY } from './constants.js';
import {
  type CreateTransformationOptions,
  type FindAllLinkedFeedsOptions,
  type FindAllLinkedFeedsResponse,
  type FindAllTransformationsOptions,
  type FindAllTransformationsResponse,
  type FindByIdOptions,
  type Transformation,
  type TransformationDefinition,
  type TransformationValidationResult,
} from '../models/resourceGateway/transformation.js';

export interface ValidateTransformationOptions {
  transformationDefinition: TransformationDefinition;
}

export class API {
  common: Common;
  baseEndpoint = '/resource-gateway/integration-gateway/transformations';

  constructor(common: Common) {
    this.common = common;
  }

  async validate(options: ValidateTransformationOptions): Promise<TransformationValidationResult> {
    const url = this.common.constructPath(`${this.baseEndpoint}/validate`);
    return await this.common.postJSON(url, options);
  }

  async create(options: CreateTransformationOptions): Promise<{ transformation: Transformation }> {
    const { organizationId, name, transformationDefinition } = options;
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.fetchJsonWithCustomHeaders({
      url,
      method: 'POST',
      body: { name, transformationDefinition },
      headers: { [ORGANIZATION_ID_HEADER_KEY]: organizationId },
    });
  }

  async findAll(options: FindAllTransformationsOptions): Promise<FindAllTransformationsResponse> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findById(options: FindByIdOptions): Promise<{ transformation: Transformation }> {
    const { transformationId } = options;
    const url = this.common.constructPath(`${this.baseEndpoint}/${transformationId}`);
    return await this.common.getJSON(url);
  }

  async findAllLinkedFeeds(
    options: FindAllLinkedFeedsOptions
  ): Promise<FindAllLinkedFeedsResponse> {
    const { organizationId, transformationId } = options;
    const url = this.common.constructPath(`${this.baseEndpoint}/${transformationId}/feeds`, {
      organizationId,
    });
    return await this.common.getJSON(url);
  }
}
